import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { CollectionModule } from 'app/modules/collection/collection.module';

import { AddToWidgetGroupDialogComponent } from './components/add-to-widget-group-dialog/add-to-widget-group-dialog.component';
import { InteractiveSmartSummaryComponent } from './components/interactive-smart-summary/interactive-smart-summary.component';
import { WidgetChartComponent } from './components/widget-chart/widget-chart.component';

@NgModule({
  imports: [
    AppSharedModule,
    CollectionModule,
    AddToWidgetGroupDialogComponent,
    InteractiveSmartSummaryComponent,
  ],
  declarations: [WidgetChartComponent],
  exports: [WidgetChartComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WidgetChartModule {}
